"use client"

import {Form, Spin} from "antd";
import {useAppDispatch, useAppSelector} from "@/store";
import {removeValidations, removeValidationsByName, selectGlobalSelector} from "@/store/slices/globaleSlice";
import {useEffect} from "react";

export const MyForm = ({form, name, spinning = false, onFieldsChange, ...rest}) => {
    const dispatch = useAppDispatch()
    const {validations} = useAppSelector(selectGlobalSelector)

    const useEffectKay = Array.isArray(validations)
        ? validations.errors ? validations.errors.length : validations.length
        : Object.keys(validations).length

    useEffect(() => {
        if (form){
            resetErrors()
            setErrors()
        }
    }, [useEffectKay]);

    useEffect(()=>{
        return () =>{
            dispatch(removeValidations())
        }
    }, [])

    const getErrorValue = (errors) =>{
        return Object.keys(errors).map((item)=>({
            name: item.split('.').map((item)=>isNaN(parseInt(item)) ? item : parseInt(item)),
            errors: errors[item],
        }))
    }
    const getErrors = () =>{
        if (Array.isArray(validations)){
            const errors = validations.filter((item)=>item.formName === name)
            if (errors[0] && errors[0].errors){
                return getErrorValue(errors[0].errors)
            }

            return []
        }else {
            return getErrorValue(validations)
        }
    }

    const setErrors = () =>{
        form.setFields(getErrors());
    }

    const resetErrors = () =>{
        form.getFieldsError().forEach((field)=>{
            if (field.errors.length){
                resetFieldsErrors(field)
            }
        })
    }

    const resetFieldsErrors = (field) =>{
        form.setFields([
            {
                name: field.name, // required
                errors: null,
            },
        ]);
    }

    const onFieldsChangeHandler = (changedFields) =>{
        if (form){
            const errors = getErrors()

            changedFields.forEach(((field)=>{
                const isFindServerError = errors.find((item)=>{
                    return item.name.toString().replaceAll(',', '.') === field.name.toString().replaceAll(',', '.')
                })

                if (isFindServerError){
                    resetFieldsErrors(field)

                    dispatch(removeValidationsByName({
                        name: field.name.toString().replaceAll(',', '.'),
                        formName: name
                    }))
                }
            }))
        }

        if (onFieldsChange){
            onFieldsChange(changedFields)
        }
    }

    return (
        <>
            <Spin spinning={spinning}>
                <Form
                    form={form}
                    name={name}
                    onFieldsChange={onFieldsChangeHandler}
                    {...rest}
                />
            </Spin>
        </>
    );
}